var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { LotteryBrandPriceModel, CurrencyEnum, borderColor } from '../../../../../models/modules/lotteryplatofrm.models';
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import * as Enumerable from 'linq';
import { LotteryClientService } from '../../../../../services/modules/lottery-client.service';
import { CurrencyClientService } from '../../../../../services/modules/currency-client.service';
import { BindingSignaler } from "aurelia-templating-resources";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
var BundleTickets = /** @class */ (function (_super) {
    __extends(BundleTickets, _super);
    function BundleTickets(notificationService, i18N, lotteryClientService, currencyClientService, signaler, dialogClient) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.currencyClientService = currencyClientService;
        _this.signaler = signaler;
        _this.dialogClient = dialogClient;
        _this._promiseCount = 0;
        _this.message = null;
        return _this;
    }
    BundleTickets.prototype.onShouldUpdateRateChanged = function ($event, itemLotteryBrandPrice) {
        var _this = this;
        var isChecked = $event.detail.value;
        if (isChecked) {
            var rate = this.rates.firstOrDefault(function (x) { return x.currencyId == itemLotteryBrandPrice.currencyId; });
            var defaultPrice = Enumerable.from(this.pricingModel.lotteryBrandPrices).firstOrDefault(function (s) { return s.currencyId == _this.defaultCurrencyId; });
            if (rate) {
                itemLotteryBrandPrice.price = rate.euroRate * defaultPrice.price;
            }
        }
    };
    BundleTickets.prototype.isCurrencyNotEuro = function (currencyId) {
        return currencyId != CurrencyEnum.Euro;
    };
    BundleTickets.prototype.isCurrencyEuro = function (currencyId) {
        return currencyId == CurrencyEnum.Euro;
    };
    // show delete icon for all currencies except euro
    BundleTickets.prototype.canDeleteCurrency = function (currencyId) {
        var findEuroInArray = Enumerable.from(this.pricingModel.lotteryBrandPrices)
            .where(function (x) { return x.currencyId == CurrencyEnum.Euro; }).toArray();
        return (currencyId != CurrencyEnum.Euro) || (currencyId == CurrencyEnum.Euro && findEuroInArray.length > 1);
    };
    BundleTickets.prototype.addTicketPrice = function (currencyModel) {
        var model = new LotteryBrandPriceModel();
        model.currencyId = currencyModel ? currencyModel.currencyId : 0;
        model.lotteryPricingModelId = this.pricingModel.lotteryPricingModelId;
        model.price = 0;
        model.decimalPointRounding = 2;
        model.countryId = null;
        model.lotteryJackpotRangeId = null;
        model.addBorderStyle = this.ticketPriceWithNewCurrency(currencyModel) ? { 'border': borderColor.orange } : null;
        if (this.message == null && model.addBorderStyle != null) {
            this.message = this.i18N.tr("ticket-price-updated-by-new-currency");
        }
        this.pricingModel.lotteryBrandPrices.push(model);
        this.signaler.signal("reloadPrices");
    };
    BundleTickets.prototype.ticketPriceWithNewCurrency = function (currencyModel) {
        // this condition is checking for if the currency is already saved for ticket price
        return !Enumerable.from(this.pricingModel.lotteryBrandPrices)
            .distinct().select(function (x) { return x.currencyId; }).toArray().includes(currencyModel ? currencyModel.currencyId : 0);
    };
    BundleTickets.prototype.onPriceChanged = function ($event, brandPriceItem) {
        var _this = this;
        if (brandPriceItem && brandPriceItem.currencyId == this.defaultCurrencyId) {
            var value_1 = $event.detail.newValue;
            var count_1 = ++this._promiseCount;
            Enumerable.from(this.pricingModel.lotteryBrandPrices).where(function (x) { return x.currencyId != _this.defaultCurrencyId
                && x.shouldUpdateCurrencyRate; }).forEach(function (price) {
                var rate = _this.rates == undefined ? false : _this.rates.firstOrDefault(function (x) { return x.currencyId == price.currencyId; });
                if (rate) {
                    _this.lotteryClientService.calculatePrice({
                        currencyRate: rate.euroRate,
                        roundNearest: 2,
                        price: Number(value_1)
                    }).then(function (calculatedResult) {
                        if (_this._promiseCount == count_1) {
                            price.price = calculatedResult.calculatedPrice;
                        }
                    });
                }
            });
        }
    };
    BundleTickets.prototype.onRoundingChanged = function ($event, itemLotteryBrandPrice) {
        var _this = this;
        if (itemLotteryBrandPrice && itemLotteryBrandPrice.currencyId != this.defaultCurrencyId) {
            var rate = this.rates.firstOrDefault(function (x) { return x.currencyId == itemLotteryBrandPrice.currencyId; });
            var defaultPriceEntry = Enumerable.from(this.pricingModel.lotteryBrandPrices).firstOrDefault(function (lbp) { return lbp.currencyId == _this.defaultCurrencyId; });
            var count_2 = ++this._promiseCount;
            this.lotteryClientService.calculatePrice({
                currencyRate: rate.euroRate,
                roundNearest: itemLotteryBrandPrice.decimalPointRounding,
                price: Number(defaultPriceEntry.price)
            }).then(function (calculatedResult) {
                if (_this._promiseCount == count_2) {
                    itemLotteryBrandPrice.price = calculatedResult.calculatedPrice;
                }
            });
        }
    };
    Object.defineProperty(BundleTickets.prototype, "isReadonly", {
        get: function () {
            if (this.item.bundleId == undefined)
                return true;
            else if (!this.pricingModel || !this.item || !this.item.navigationInfo)
                return true;
            return this.item.navigationInfo.brandId && this.item.navigationInfo.brandId != this.pricingModel.brandId;
        },
        enumerable: false,
        configurable: true
    });
    BundleTickets.prototype.onActivated = function (item) {
        var _this = this;
        this.defaultCurrencyId = CurrencyEnum.Euro; // by default all ticket prices are set as euros. 
        this.defaultCurrency = Enumerable.from(this.currencies).firstOrDefault(function (x) { return x.currencyId == _this.defaultCurrencyId; }); // get default currency name
        // this.defaultCurrencyId = this.item.navigationInfo && this.item.navigationInfo.brandId ?this.item.navigationInfo.brandDefaultCurrencyId: null;
        this.currencyClientService.getRates().then(function (rates) {
            _this.rates = Enumerable.from(rates);
        });
        if (!item.pricingModels)
            item.pricingModels = [];
        this.pricingModel = item.pricingModels[0];
        this.setTicketPricesOnLoad();
    };
    BundleTickets.prototype.setTicketPricesOnLoad = function () {
        return __awaiter(this, void 0, void 0, function () {
            var brandCurrencyList, currencyCount, i;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.pricingModel["brand"] != null)) return [3 /*break*/, 2];
                        brandCurrencyList = this.pricingModel["brand"]["brandCurrencies"];
                        brandCurrencyList = brandCurrencyList.filter(function (x) { return !Enumerable.from(_this.pricingModel.lotteryBrandPrices)
                            .distinct().select(function (x) { return x.currencyId; }).toArray().includes(x.currencyId); });
                        return [4 /*yield*/, this.currencyClientService.getCurrencies().then(function (x) {
                                _this.currencies = x.filter(function (x) { return Enumerable.from(brandCurrencyList).select(function (x) { return x.currencyId; }).toArray().includes(x.currencyId); });
                                _this.defaultCurrency = Enumerable.from(x).firstOrDefault(function (x) { return x.currencyId == _this.defaultCurrencyId; });
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        currencyCount = this.currencies == undefined ? 0 : this.currencies.length;
                        for (i = 0; i < currencyCount; i++) {
                            this.addTicketPrice(this.currencies[i]);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BundleTickets.prototype.getPricesForRange = function () {
        var prices = this.pricingModel && this.pricingModel.lotteryBrandPrices ?
            Enumerable.from(this.pricingModel.lotteryBrandPrices).where(function (x) { return x.lotteryJackpotRangeId == null; }).toArray()
            : [];
        return prices;
    };
    BundleTickets.prototype.removePrice = function (itemLotteryBrandPrice) {
        var _this = this;
        var eurosCountInArray = Enumerable.from(this.pricingModel.lotteryBrandPrices)
            .count(function (x) { return x.currencyId == CurrencyEnum.Euro && x.currencyId == itemLotteryBrandPrice.currencyId; });
        if (eurosCountInArray != 1) {
            require("../../dialogs/delete-modal");
            this.dialogClient.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
                delete: function () { return new Promise(function (resolve, reject) {
                    resolve();
                    // check bundleId exist for creating new bundle
                    if (_this.item.bundleId == undefined) {
                        _this.removeTicketPrice(itemLotteryBrandPrice);
                        _this.dialogClient.hide();
                    }
                    else if (_this.pricingModel["brand"] != null) {
                        var brandCurrencyList = _this.pricingModel["brand"]["brandCurrencies"];
                        if (brandCurrencyList.find(function (x) { return x.currencyId == itemLotteryBrandPrice.currencyId; }) == undefined || Enumerable.from(_this.pricingModel.lotteryBrandPrices)
                            .count(function (x) { return x.currencyId == itemLotteryBrandPrice.currencyId; }) > 1) {
                            _this.removeTicketPrice(itemLotteryBrandPrice);
                            _this.dialogClient.hide();
                        }
                        else {
                            _this.notificationService.show("Validation Error!", "This currency cannot be deleted. You need to unselect the currency from the brand settings and then you can delete it from here", NotificationType.Error);
                            _this.dialogClient.hide();
                        }
                    }
                    else {
                        _this.notificationService.show("Validation Error!", "You cannot able to delete currencies from operator level.", NotificationType.Error);
                        _this.dialogClient.hide();
                    }
                }); }
            });
        }
        else {
            this.notificationService.show("Validation Error!", "You are not able to delete Euro as a Master Ticket", NotificationType.Error);
        }
    };
    BundleTickets.prototype.removeTicketPrice = function (itemLotteryBrandPrice) {
        var index = this.pricingModel.lotteryBrandPrices.indexOf(itemLotteryBrandPrice);
        this.pricingModel.lotteryBrandPrices.splice(index, 1);
        this.signaler.signal("reloadPrices");
    };
    BundleTickets.prototype.currencyDropdownChanged = function () {
        var lotteryBrandPricingList = Enumerable.from(this.pricingModel.lotteryBrandPrices).toArray();
        for (var i = 0; i < lotteryBrandPricingList.length; i++) {
            Enumerable.from(lotteryBrandPricingList).where(function (x) { return x.currencyId == lotteryBrandPricingList[i].currencyId; })
                .forEach(function (val) { if (val.addBorderStyle != undefined && val.addBorderStyle["border"].includes('red'))
                val.addBorderStyle = null; });
        }
        var nonUniqueCurrencies = Enumerable.from(lotteryBrandPricingList).where(function (x) { return x.currencyId != 0; }).select(function (x) { return x.currencyId; }).toArray().filter(function (val, indexVal, currencyArray) { return currencyArray.indexOf(val) !== indexVal; });
        for (var i = 0; i < nonUniqueCurrencies.length; i++) {
            var findAlreadySelectedCurrency = Enumerable.from(lotteryBrandPricingList).where(function (x) { return x.currencyId == nonUniqueCurrencies[i] && x.currencyId != 0; }).firstOrDefault();
            findAlreadySelectedCurrency.addBorderStyle = { 'border': borderColor.red };
            var currencyName = Enumerable.from(this.currencies).firstOrDefault(function (x) { return x.currencyId == findAlreadySelectedCurrency.currencyId; }).name;
            this.notificationService.show("Validation Error!", currencyName + " currency is already exist. You cannot able to select again.", NotificationType.Error);
        }
    };
    Object.defineProperty(BundleTickets.prototype, "masterTicket", {
        get: function () {
            var _this = this;
            if (this.pricingModel && this.pricingModel.lotteryBrandPrices) {
                var master = Enumerable.from(this.pricingModel.lotteryBrandPrices).firstOrDefault(function (x) { return x.currencyId == _this.defaultCurrencyId; });
                return master;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    BundleTickets = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            LotteryClientService, CurrencyClientService, BindingSignaler, DialogClientService])
    ], BundleTickets);
    return BundleTickets;
}(ChildComponent));
export { BundleTickets };
